import React, { useState } from 'react';

// Outline files are named after the lowercased image, except where the outline set used a different name.
const OUTLINE_NAME_OVERRIDES: Record<string, string> = {
  'hard-hat': 'hardhat',
  'nightshift': 'night',
  'bankholiday': 'bank-holiday',
};

function getOutlineIcon(colour: string, image: string) {
  const name = image.replace(/\.svg$/i, '').toLowerCase();
  const outlineName = OUTLINE_NAME_OVERRIDES[name] ?? name;
  switch (colour) {
    case 'green': return `${outlineName}-green.svg`
    case 'yellow': return `${outlineName}-yellow.svg`
    default: return `${outlineName}-grey.svg`
  }
}

export function WhereaboutsIconOutline(props: Props) {
  const title = props.label
  const imageUrl = props.image ? `/assets/icons/outline-icons/${getOutlineIcon(props.colour, props.image)}` : '';
  // Images without an outline version fall back to the dot once the request fails
  const [failedUrl, setFailedUrl] = useState<string>();

  if (!imageUrl || failedUrl === imageUrl) {
    return <WhereaboutsIconOutlineUnknown stopPropagation={props.stopPropagation} />
  }

  return <img title={title} style={{marginRight: 16}}
              className={"whereabouts__outlineIcon"}
              src={imageUrl}
              onError={() => setFailedUrl(imageUrl)}
              onMouseOver={(e: any) => !!props.stopPropagation ? e.stopPropagation() : false}
              onMouseLeave={(e: any) => !!props.stopPropagation ? e.stopPropagation() : false}
              onTouchStart={(e: any) => !!props.stopPropagation ? e.stopPropagation() : false}
              onTouchEnd={(e: any) => !!props.stopPropagation ? e.stopPropagation() : false}
              onTouchCancel={(e: any) => !!props.stopPropagation ? e.stopPropagation() : false}
              alt="" />;
}

export function WhereaboutsIconOutlineUnknown(props: {stopPropagation?: boolean}) {
  return <img className={"whereabouts__outlineIcon"}
              style={{marginRight: 16}}
              src="/assets/icons/outline-icons/dot-outline.svg"
              onMouseOver={(e: any) => !!props.stopPropagation ? e.stopPropagation() : false}
              onMouseLeave={(e: any) => !!props.stopPropagation ? e.stopPropagation() : false}
              onTouchStart={(e: any) => !!props.stopPropagation ? e.stopPropagation() : false}
              onTouchEnd={(e: any) => !!props.stopPropagation ? e.stopPropagation() : false}
              onTouchCancel={(e: any) => !!props.stopPropagation ? e.stopPropagation() : false}
              alt="" />
}

interface Props {
  image: string;
  label: string;
  colour: string;
  stopPropagation?: boolean;
}
